module.exports = __webpack_public_path__ + "static/loosechange-1-1712342d0245678a9ac0d9da1669a2c9.png";